import Image from "next/image";
import { Box, Typography } from "@mui/material";
import Head from "next/head"; // Import the Head component

export default function OceanCityInfoPage() {
  return (
    <>
      <Head>
        <title>Live Music in Ocean City, MD | Webtunes</title>
        <meta
          name="description"
          content="Discover the best live music events happening in Ocean City, Maryland."
        />
        <meta
          name="keywords"
          content="Ocean City live music, concerts, events, venues, shows"
        />
        <meta property="og:title" content="Live Music in Ocean City, MD" />
        <meta
          property="og:description"
          content="Explore Ocean City live music venues, events, and shows."
        />
        <meta
          property="og:image"
          content="https://webtunes.com/ocean_city.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Live Music in Ocean City, MD" />
        <meta
          name="twitter:description"
          content="Explore Ocean City live music venues, events, and shows."
        />
        <meta
          name="twitter:image"
          content="https://webtunes.com/ocean_city.jpg"
        />
        <link
          rel="icon"
          href="/favicon.ico"
          type="image/x-icon"
          sizes="16x16"
        />
      </Head>

      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" gutterBottom>
          Ocean City Live Music Guide
        </Typography>

        <Typography variant="body1" gutterBottom>
          Experience Live Music in Ocean City with Webtunes Discover the vibrant
          live music scene in Ocean City, Maryland! From beachside bars and
          restaurants to lively concert venues, Ocean City offers a unique blend
          of entertainment for music lovers. Enjoy live performances from local
          bands, regional favorites, and touring artists as you soak up the
          coastal vibes. Whether it’s a relaxing acoustic set or an energetic
          evening of dancing, Webtunes is your guide to the best live music
          events in Ocean City. Explore upcoming shows and make your next beach
          trip unforgettable with Webtunes!
        </Typography>

        <Typography variant="body2" color="textSecondary" gutterBottom>
          <strong>Plan your perfect Ocean City live music night:</strong> Search
          by <strong>venue</strong>, <strong>band</strong>,{" "}
          <strong>date</strong>, or <strong>location</strong>. Use our{" "}
          <strong>interactive map</strong> to find live music near you and never
          miss a show in Ocean City again.
        </Typography>

        <Box sx={{ my: 3 }}>
          <Image
            src="/ocean_city.jpg"
            alt="Ocean City Live Music"
            width={800}
            height={500}
            style={{ borderRadius: "12px", objectFit: "cover" }}
          />
        </Box>

        <Box sx={{ mt: 3 }}>
          <a href="/events?location=ocean-city">
            See Ocean City, MD Live Music Events
          </a>
        </Box>
      </Box>
    </>
  );
}
